import {
  FieldTypesConfigList,
  FormBuilderInterface,
  FormTypeInterface,
} from '@ckmk/angular';
import { Injectable, inject } from '@angular/core';
import { PostCategoryService } from '@app/src/app/modules/post/service/post.category.service';

@Injectable({
  providedIn: 'root',
})
export class PostFilterFormType implements FormTypeInterface {
  protected readonly categoryService = inject(PostCategoryService);

  public fields: FieldTypesConfigList = [];

  public constructor() {}

  public async configure(builder: FormBuilderInterface): Promise<void> {
    builder.add({
      name: 'categories',
      label: 'Categories',
      type: 'select',
      required: false,
      config: {
        multiple: true,
        options: (search?: string) =>
          this.categoryService.filterCategoriesOptions(search),
      },
    });
  }
}
